import styled from 'styled-components';

export const TabPanelWrapper = styled.div`
  color: ${({ theme }) => theme.colors.black};
  width: 100%;

  @media (min-width: ${({ theme }) => theme.breakpoints.small}px) {
    max-width: 428px;
  }
`;

export const TabPanelHeader = styled.p`
  padding: 14px 0 30px 0;
  margin-bottom: 0;
`;
